import { postRequest } from '@/core';
import { incoterms } from '@/requests';

export default async function getIncotermsRequest() {
	let url = incoterms.getSyncPath();
	let response = await postRequest(url);
	return response;
}